function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "a",
  width: 23,
  height: 23,
  x: 1.5,
  y: 1.5,
  rx: 11.5
}), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: "113%",
  height: "113%",
  x: "-6.5%",
  y: "-6.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: -3,
  in: "SourceAlpha",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1",
  values: "0 0 0 0 0.82745098 0 0 0 0 0.831372549 0 0 0 0 0.866666667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#696979",
  fillRule: "nonzero",
  d: "M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0zm0 1.53C6.665 1.53 1.53 6.664 1.53 13c0 6.335 5.135 11.47 11.47 11.47 6.335 0 11.47-5.135 11.47-11.47 0-6.335-5.135-11.47-11.47-11.47z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#F0F0F5",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#b)",
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#696979",
  d: "M8.65 17.096a5.018 5.018 0 0 1 8.685 0 .749.749 0 1 1-1.295.75 3.52 3.52 0 0 0-6.094 0 .749.749 0 0 1-1.295-.75zM6.315 6.93l3.434.92a.672.672 0 0 1-.012 1.3c.35.412.57 1.019.57 1.695 0 1.248-.752 2.26-1.68 2.26-.927 0-1.678-1.012-1.678-2.26 0-.935.421-1.737 1.023-2.081l-2.004-.536a.672.672 0 1 1 .347-1.298zm14.18.475a.672.672 0 0 1-.38.79l-.095.033-2.004.536c.602.344 1.023 1.146 1.023 2.08 0 1.25-.751 2.261-1.679 2.261-.927 0-1.68-1.012-1.68-2.26 0-.676.221-1.283.571-1.697a.663.663 0 0 1-.487-.475.672.672 0 0 1 .381-.79l.094-.033 3.434-.92a.672.672 0 0 1 .822.475z"
}));

var SvgMtInsatisfeitoCinza = function SvgMtInsatisfeitoCinza(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMtInsatisfeitoCinza, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mt-insatisfeito-cinza.bea1bdca.svg";
export { ForwardRef as ReactComponent };